import React, { useEffect, useState } from 'react'


import { Badge, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  array, number, bool, func, string, object,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const averageTagWidth = 40
const averagePriceTagWidth = 65
const averageDiscountTagWidth = 42
const plusSomethingTagWidth = 30
const extraSpace = 20

function ModelCardFormatTags({
  tags = EMPTY_ARRAY,
  tagsCount = 0,
  currentSelectedFileTypes,
  setSelectedFilters,
  trackFilterChange,
  isVisible,
  cardSizeSetting,
  isDiscountOrRibbonTagsActive,
  articleRef,
}) {
  const [initialAvailableWidth, setInitialAvailableWidth] = useState(0)
  const [maxTagsCount, setMaxTagsCount] = useState(4)

  useEffect(() => {
    function handleResize() {
      setInitialAvailableWidth(articleRef.current?.clientWidth)
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (!initialAvailableWidth) {
      return
    }

    setMaxTagsCount(() => {
      let tagsToShow = 0
      let availableWidth = initialAvailableWidth - averagePriceTagWidth - plusSomethingTagWidth - extraSpace
      if (isDiscountOrRibbonTagsActive) {
        availableWidth -= averageDiscountTagWidth
      }

      while (availableWidth > 0) {
        availableWidth -= averageTagWidth
        tagsToShow += 1
      }

      return tagsToShow
    })
  }, [initialAvailableWidth, cardSizeSetting])

  function triggerFiltersChange(isCurrentlySelected, id, selectedLabel) {
    if (isCurrentlySelected) {
      setSelectedFilters({
        name: 'fileTypes',
        value: currentSelectedFileTypes.filter((item) => item !== `${id}`),
      })
    } else {
      trackFilterChange({
        name: 'fileTypes',
        value: selectedLabel,
        eventSource: 'model card',
      })
      setSelectedFilters({
        name: 'fileTypes',
        value: [...currentSelectedFileTypes, `${id}`],
      })
    }
  }

  const badges = tags
    .filter(({ name }) => !!name)
    .map(({ name, id }) => {
      const isSelected = currentSelectedFileTypes.includes(`${id}`)
      const selectedLabel = name.replace(/\./g, '')

      return ({
        isSelected,
        type: isSelected ? 'primary' : 'white',
        hasBorder: !isSelected,
        value: selectedLabel,
        onClick: () => triggerFiltersChange(isSelected, id, selectedLabel),
      })
    })
    .sort((a, b) => b.isSelected - a.isSelected)
    .slice(0, maxTagsCount)

  const moreItemsCount = tagsCount > maxTagsCount ? {
    type: 'white',
    hasBorder: true,
    value: `+${tagsCount - maxTagsCount}`,
    className: 'card-3d-model__format-tags__more-items',
  } : null

  const temp = [...badges, moreItemsCount].filter(Boolean)

  return (
    <div className={classnames(
      'card-3d-model__format-tags',
      isVisible && 'card-3d-model__format-tags--visible',
    )}
    >
      {temp.map(({
        type, value, hasBorder, onClick, className,
      }) => (
        <Badge type={type} onClick={onClick} hasBorder={hasBorder} key={value} className={className}>
          {value}
        </Badge>
      ))}
    </div>
  )
}

ModelCardFormatTags.propTypes = {
  tags: array,
  tagsCount: number,
  currentSelectedFileTypes: array.isRequired,
  setSelectedFilters: func.isRequired,
  trackFilterChange: func.isRequired,
  isVisible: bool.isRequired,
  cardSizeSetting: string.isRequired,
  isDiscountOrRibbonTagsActive: bool.isRequired,
  articleRef: object.isRequired,
}

export default ModelCardFormatTags
